<template>
  <div class="user">
    <!--添加任务-->
    <div class="common-seach-wrap">
      <el-form :inline="true" size="small" :model="formInline" class="demo-form-inline">
         <el-form-item label="签名分类">
          <el-select 
            v-model="formInline.sign_type_id" 
            placeholder="请选择签名分类"
            clearable
            filterable
            style="width: 200px;"
          >
            <el-option
              v-for="dept in signTypeList"
              :key="dept.sign_type_id"
              :label="dept.name"
              :value="dept.sign_type_id"
            />
          </el-select>
        </el-form-item>
         <el-form-item label="所属组织">
          <el-select 
            v-model="formInline.ma_company_id" 
            placeholder="请选择所属组织"
            clearable
            filterable
            style="width: 200px;"
          >
            <el-option
              v-for="dept in companyList"
              :key="dept.ma_company_id"
              :label="dept.name"
              :value="dept.ma_company_id"
            />
          </el-select>
        </el-form-item>
         <el-form-item label="审核状态">
          <el-select 
            v-model="formInline.audit_status" 
            placeholder="请选择审核状态"
            clearable
            style="width: 200px;"
          >
            <el-option label="未审核" value="0"></el-option>
            <el-option label="已审核" value="1"></el-option>
            <el-option label="未通过" value="2"></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="申请时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.apply_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item label="审核时间">
          <div class="block">
            <span class="demonstration"></span>
            <el-date-picker v-model="formInline.audit_time" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期"></el-date-picker>
          </div>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="getData">查询</el-button>
          <el-button size="small" icon="el-icon-download" @click="exportData">导出Excel{{ selectedRows.length > 0 ? '(' + selectedRows.length + ')' : '' }}</el-button>
          <el-button size="small" icon="el-icon-upload2" @click="importClick">导入</el-button>
          <el-button size="small" @click="batchForbidden(1)">批量审核通过</el-button>
          <el-button size="small" @click="batchForbidden(2)">批量审核不通过</el-button>
        </el-form-item>
      </el-form>
    </div>

    <div class="common-level-rail">
      <el-button size="small" icon="el-icon-plus" type="primary" @click="addClick">添加责任签署</el-button>
    </div>

    <div class="product-content">
      <el-form ref="form" :model="form" label-width="100px">
        <div class="table-wrap">
          <el-table 
            size="small" 
            :data="tableData" 
            border 
            style="width: 100%" 
            v-loading="loading" 
            @selection-change="handleSelectionChange"
            ref="multipleTable"
          >
            <el-table-column type="selection" width="45"></el-table-column>
            <el-table-column prop="name" label="责任签署名称"></el-table-column>
            <el-table-column prop="ma_organization_name" label="所属组织"></el-table-column>
            <el-table-column prop="id_card" label="身份证号"></el-table-column>
            <el-table-column prop="signature" label="签名" width="100">
              <template slot-scope="scope">
                <div v-if="scope.row.signature" style="display: flex; justify-content: center;">
                  <!-- 尝试作为图片显示 -->
                  <img 
                    v-if="scope.row.signature.includes('.jpg') || scope.row.signature.includes('.png') || scope.row.signature.includes('.jpeg') || scope.row.signature.includes('.gif')"
                    :src="getImageUrl(scope.row.signature)" 
                    alt="签名" 
                    style="width: 80px; height: 40px; object-fit: contain; cursor: pointer;"
                    @click="previewImage(scope.row.signature)"
                  />
                  <!-- 如果是base64图片 -->
                  <img 
                    v-else-if="scope.row.signature.startsWith('data:image')"
                    :src="scope.row.signature" 
                    alt="签名" 
                    style="width: 80px; height: 40px; object-fit: contain; cursor: pointer;"
                    @click="previewImage(scope.row.signature)"
                  />
                  <!-- 如果是文本，显示文本 -->
                  <span v-else>
                    {{ scope.row.signature.length > 4 ? scope.row.signature.substring(0, 4) + '...' : scope.row.signature }}
                  </span>
                </div>
                <span v-else style="color: #999">无</span>
              </template>
            </el-table-column>
            <el-table-column prop="car_number" label="车牌号"></el-table-column>
            <el-table-column prop="apply_time" label="申请时间"></el-table-column>
            
            <!-- 关联安全承诺书列 -->
            <el-table-column prop="st_con" label="关联安全承诺书" width="120">
              <template slot-scope="scope">
                <el-button 
                  v-if="scope.row.st_con && scope.row.st_con.length > 0" 
                  type="text" 
                  size="small" 
                  @click="viewPromiseBook(scope.row)"
                >查看</el-button>
                 <span v-else style="color: #999">无</span>
              </template>
            </el-table-column>
            
            <!-- 审核状态列 -->
            <el-table-column prop="audit_status" label="审核状态" width="120">
              <template slot-scope="scope">
                <span :style="{color: scope.row.audit_status == 1 ? '#67C23A' : scope.row.audit_status == 2 ? '#F56C6C' : '#909399'}">
                  {{ getAuditStatusText(scope.row.audit_status) }}
                </span>
                <el-button 
                  v-if="scope.row.audit_status == 0" 
                  type="text" 
                  size="small" 
                  @click="auditClick(scope.row)"
                >审核</el-button>
              </template>
            </el-table-column>
            
            <el-table-column prop="user_name" label="审核人"></el-table-column>
            <el-table-column prop="audit_time" label="审核时间"></el-table-column>
            <el-table-column prop="sort" label="排序"></el-table-column>
            <el-table-column prop="create_time" label="创建时间" width="150"></el-table-column>
            <el-table-column fixed="right" label="操作" width="120">
              <template slot-scope="scope">
                <el-button @click="editClick(scope.row)" type="text" size="small">编辑</el-button>
                <el-button @click="deleteClick(scope.row)" type="text" size="small">删除</el-button>
              </template>
            </el-table-column>
          </el-table>
        </div>
      </el-form>
      
      <!--分页-->
      <div class="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next, jumper"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
    </div>

    <!-- 添加弹窗 -->
    <Add :open_add="open_add" v-if="open_add" @close="closeAdd"></Add>
    
    <!-- 编辑弹窗 -->
    <Edit :open_add="open_edit" :ma_resp_signing_id="ma_resp_signing_id" v-if="open_edit" @close="closeEdit"></Edit>
    
    <!-- 导入弹窗 -->
    <Import :open_import="open_import" v-if="open_import" @close="closeImport"></Import>
    
    <!-- 审核弹窗 -->
    <el-dialog
      title="审核责任签署"
      :visible.sync="auditDialogVisible"
      width="500px"
      @close="closeAuditDialog"
      :close-on-click-modal="false"
    >
      <el-form ref="auditForm" :model="auditForm" :rules="auditRules" label-width="100px">
        <el-form-item label="审核状态" prop="audit_status">
          <el-radio-group v-model="auditForm.audit_status">
            <el-radio :label="1">通过</el-radio>
            <el-radio :label="2">不通过</el-radio>
          </el-radio-group>
        </el-form-item>
        
        <el-form-item 
          v-if="auditForm.audit_status === 2" 
          label="不通过理由" 
          prop="audit_reason"
        >
          <el-input
            type="textarea"
            v-model="auditForm.audit_reason"
            placeholder="请输入不通过的理由"
            :rows="3"
            maxlength="200"
            show-word-limit
          ></el-input>
        </el-form-item>
      </el-form>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeAuditDialog" size="small">取消</el-button>
        <el-button type="primary" @click="submitAudit" size="small" :loading="auditLoading">提交</el-button>
      </span>
    </el-dialog>
    
    <!-- 查看安全承诺书弹窗 -->
    <el-dialog
      title="安全承诺书"
      :visible.sync="promiseDialogVisible"
      width="800px"
      @close="closePromiseDialog"
      :close-on-click-modal="false"
    >
      <div class="promise-content" style="max-height: 600px; overflow-y: auto;">
        <div v-if="currentRow && currentRow.st_con">
          <!-- 如果st_con是HTML格式 -->
          <div v-if="isHtmlContent(currentRow.st_con)" v-html="currentRow.st_con"></div>
          <!-- 如果st_con是纯文本格式，按格式显示 -->
          <div v-else>
            <!-- 尝试从内容中提取信息 -->
            <div v-html="formatPromiseBook(currentRow.st_con)"></div>
          </div>
        </div>
      </div>
      
      <span slot="footer" class="dialog-footer">
        <el-button @click="closePromiseDialog" size="small">关闭</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import Ma_resp_signingApi from '@/api/ma_resp_signing.js';
import Add from './part/add.vue';
import Edit from './part/edit.vue';
import Import from './part/import.vue';
import AfuncApi from '@/api/afunc.js';

export default {
  components: {
    Add,
    Edit,
    Import,
  },
  inject: ['reload'],
  data() {
    return {
      loading: true,
      tableData: [],
      pageSize: 20,
      totalDataNumber: 0,
      curPage: 1,
      form: {},
      formInline: {
        sign_type_id:'',
        ma_company_id:'',
        audit_status:'',
        apply_time:'',
        audit_time:''
      },
      open_add:false,
      open_edit:false,
      ma_resp_signing_id:"",
      dialogVisible:false,
      open_import:false,
      selection: [],
      selectedRows: [],
      auditDialogVisible: false,
      auditLoading: false,
      companyList:[],
      signTypeList:[],
      auditForm: {
        ma_resp_signing_id: '',
        audit_status: 1,
        audit_reason: ''
      },
      auditRules: {
        audit_status: [
          { required: true, message: '请选择审核状态', trigger: 'change' }
        ],
        audit_reason: [
          { required: true, message: '请输入不通过理由', trigger: 'blur' }
        ]
      },
      promiseDialogVisible: false,
      currentRow: null
    };
  },
  created() {
    this.getTableList();
    this.loadOrganization();
    this.loadSignType();
  },
  methods: {
    async batchForbidden(status) {
      let ma_resp_signing_ids = [];
      let params = this.selectedRows;
      params.forEach((param) => {
        ma_resp_signing_ids.push(param.ma_resp_signing_id);
      })
      ma_resp_signing_ids = ma_resp_signing_ids.join(',');
      console.log(ma_resp_signing_ids);
      if (ma_resp_signing_ids == '') {
        this.$message({
          message: '请选择要审核的用户',
          type: 'error'
        });
      } else {
        const response = await AfuncApi.call({
          model: 'ma_resp_signing',
          action: 'edit',
          type:2,
          status:status,
          ma_resp_signing_ids:ma_resp_signing_ids
        });
        if(response.code==1){
          this.$message({
            message: '成功',
            type: 'success'
          });
          this.getTableList();
        }
      }
    },
    getImageUrl(url) {
      if (!url) return '';
      // 如果是完整URL
      if (url.startsWith('http://') || url.startsWith('https://')) {
        return url;
      }
      // 如果是相对路径，添加基础路径
      const baseUrl = window.location.origin;
      return baseUrl + (url.startsWith('/') ? url : '/' + url);
    },
    
    // 预览图片
    previewImage(url) {
      let imageUrl = url;
      if (!url.startsWith('data:image') && !url.startsWith('http')) {
        imageUrl = this.getImageUrl(url);
      }
      
      // 使用Element UI的图片预览
      const image = new Image();
      image.src = imageUrl;
      image.onload = () => {
        const h = this.$createElement;
        this.$msgbox({
          title: '签名预览',
          customClass: 'image-preview-modal',
          message: h('div', { style: 'text-align: center;' }, [
            h('img', {
              style: 'max-width: 100%; max-height: 80vh;',
              attrs: { src: imageUrl }
            })
          ]),
          showCancelButton: false,
          confirmButtonText: '关闭'
        });
      };
      
      image.onerror = () => {
        this.$message.warning('图片加载失败');
      };
    },
    /* 加载组织列表 */
    async loadOrganization() {
      try {
        const response = await AfuncApi.call({
          model: 'ma_company',
          action: 'getList',
        });
        
        if (response.code === 1 && response.data.list && response.data.list.data) {
          this.companyList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载组织列表失败:', error);
        this.companyList = [];
      }
    },
    async loadSignType() {
      try {
        const response = await AfuncApi.call({
          model: 'sign_type',
          action: 'getList',
        });
        
        if (response.code === 1 && response.data.list.data) {
          this.signTypeList = response.data.list.data || [];
        }
      } catch (error) {
        console.error('加载列表失败:', error);
        this.signTypeList = [];
      }
    },
    getAuditStatusText(status) {
      const statusMap = {
        0: '未审核',
        1: '已通过',
        2: '不通过'
      };
      return statusMap[status] || '未知状态';
    },
    
    // 检查是否是HTML内容
    isHtmlContent(content) {
      if (!content) return false;
      const htmlRegex = /<[a-z][\s\S]*>/i;
      return htmlRegex.test(content);
    },
    
    // 格式化安全承诺书内容
    formatPromiseBook(content) {
      if (!content) return '';
      
      // 如果内容包含HTML标签，直接返回
      if (this.isHtmlContent(content)) {
        return content;
      }
      
      // 如果是纯文本，按格式处理
      let formattedContent = content;
      
      // 确保每段都有合适的换行
      formattedContent = formattedContent.replace(/\n/g, '<br>');
      
      // 添加标题样式
      if (!formattedContent.includes('<h') && !formattedContent.includes('责任书签订')) {
        formattedContent = '<h2 style="text-align: center;">责任书签订</h2>' + 
                          '<h3 style="text-align: center;">安全承诺书</h3>' + 
                          formattedContent;
      }
      
      return formattedContent;
    },
    
    viewPromiseBook(row) {
      this.currentRow = row;
      this.promiseDialogVisible = true;
    },
    
    closePromiseDialog() {
      this.promiseDialogVisible = false;
      this.currentRow = null;
    },
    
    auditClick(row) {
      this.auditForm.ma_resp_signing_id = row.ma_resp_signing_id;
      this.auditForm.audit_status = 1;
      this.auditForm.audit_reason = '';
      this.auditDialogVisible = true;
    },
    
    closeAuditDialog() {
      this.auditDialogVisible = false;
      if (this.$refs.auditForm) {
        this.$refs.auditForm.resetFields();
      }
    },
    
    async submitAudit() {
      // 验证表单
      this.$refs.auditForm.validate(async (valid) => {
        if (!valid) {
          this.$message.warning('请正确填写审核信息');
          return;
        }
        
        try {
          this.auditLoading = true;
          
          // 构建完整的参数
          const params = {
            ma_resp_signing_id: this.auditForm.ma_resp_signing_id,
            audit_status: parseInt(this.auditForm.audit_status), 
          };
          
          // 如果不通过，添加审核理由
          if (this.auditForm.audit_status == 2) {
            if (!this.auditForm.audit_reason || this.auditForm.audit_reason.trim() === '') {
              this.$message.warning('请填写不通过理由');
              this.auditLoading = false;
              return;
            }
            params.audit_reason = this.auditForm.audit_reason.trim();
          }
          params.type=1;
          
          // 调用接口
          const response = await AfuncApi.call({
            model: 'ma_resp_signing',
            action: 'edit', 
            ...params
          });
          if (response.code === 1) {
            this.$message.success(response.msg || '审核操作成功');
            this.closeAuditDialog();
            this.getTableList(); // 刷新数据列表
          } else {
            this.$message.error(response.msg || '审核操作失败');
          }
          this.auditLoading = false;
          
        } catch (error) {
          console.error('审核提交失败:', error);
          this.$message.error('审核提交失败，请检查网络或联系管理员');
          this.auditLoading = false;
        }
      });
    },
    dialogFormVisible() {
      this.dialogVisible = false;
    },
    
    setting(e) {
      this.dialogVisible = true;
    },
    
    handleSelectionChange(selection) {
      this.selectedRows = selection;
    },
    
    clearSelection() {
      if (this.$refs.multipleTable) {
        this.$refs.multipleTable.clearSelection();
      }
      this.selectedRows = [];
    },
    
    closeImport(e) {
      this.open_import = false;
      if (e.type === "success") {
        this.getTableList();
      }
    },
    
    importClick() {
      this.open_import = true;
    },
    
    exportData() {
      let exportParams = {
        name: this.formInline.search,
      };
      
      if (this.selectedRows.length > 0) {
        const selectedIds = this.selectedRows.map(row => row.ma_resp_signing_id);
        exportParams.selected_ids = selectedIds.join(',');
      }
      
      let baseUrl = window.location.protocol + '//' + window.location.host;
      let queryString = Object.keys(exportParams)
        .filter(key => exportParams[key] !== undefined && exportParams[key] !== '')
        .map(key => `${key}=${encodeURIComponent(exportParams[key])}`)
        .join('&');
      
      window.location.href = baseUrl + '/index.php/shop/plus.ma_resp_signing.Index/export?' + queryString;
    },
    
    closeAdd(e) {
      this.open_add = false;
      this.getTableList();
    },
    
    closeEdit(e) {
      this.open_edit = false;
      this.getTableList();
    },
    
    getData() {
      this.curPage = 1;
      this.getTableList();
    },
    
    handleCurrentChange(val) {
      this.curPage = val;
      this.getTableList();
    },
    
    handleSizeChange(val) {
      this.curPage = 1;
      this.pageSize = val;
      this.getTableList();
    },
    
    getTableList() {
      let self = this;
      let Params = {
        sign_type_id: this.formInline.sign_type_id,
        ma_company_id: this.formInline.ma_company_id,
        audit_status: this.formInline.audit_status,
        apply_time: this.formInline.apply_time,
        audit_time: this.formInline.audit_time,
        page: self.curPage,
        list_rows: self.pageSize
      };
      self.loading = true;
      Ma_resp_signingApi.list(Params, true)
        .then(data => {
          self.loading = false;
          if (data.code === 1 && data.data && data.data.list) {
            self.tableData = data.data.list.data || [];
            self.totalDataNumber = data.data.list.total || 0;
          } else {
            self.tableData = [];
            self.totalDataNumber = 0;
            this.$message.error(data.msg || '获取数据失败');
          }
        })
        .catch(error => {
          self.loading = false;
          self.tableData = [];
          self.totalDataNumber = 0;
          this.$message.error('获取数据失败');
        });
    },
    
    addClick() {
      this.open_add = true;
    },
    
    editClick(row) {
      this.ma_resp_signing_id = row.ma_resp_signing_id;
      this.open_edit = true;
    },
    
    deleteClick(row) {
      let self = this;
      self.$confirm('此操作将永久删除该记录, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        Ma_resp_signingApi.del({
          ma_resp_signing_id: row.ma_resp_signing_id
        }, true).then(data => {
          if (data.code == 1) {
            self.$message.success('删除成功');
            this.getTableList();
          } else {
            self.$message.error(data.msg || '删除失败');
          }
        }).catch(error => {
          self.$message.error('删除失败');
        });
      }).catch(() => {});
    }
  }
};
</script>

<style scoped>
.image-preview-modal {
  width: auto;
  max-width: 90%;
}

/* 错误状态图片样式 */
.image-slot {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 80px;
  height: 40px;
  background: #f5f7fa;
  color: #909399;
}

.el-image {
  border: 1px solid #ebeef5;
  border-radius: 4px;
  transition: border-color 0.3s;
}

.el-image:hover {
  border-color: #409eff;
}
.promise-content {
  font-family: 'Microsoft YaHei', Arial, sans-serif;
  line-height: 1.6;
  color: #333;
}

.promise-content h2,
.promise-content h3 {
  margin: 20px 0;
  font-weight: bold;
}

.promise-content p {
  margin: 10px 0;
  text-indent: 2em;
}

.promise-content .sign-info {
  margin-top: 30px;
  text-align: left;
}

.promise-content .sign-info p {
  text-indent: 0;
  line-height: 2;
}

/* 表格中查看按钮的样式 */
.el-button--text {
  margin-left: 5px;
}
</style>


// WEBPACK FOOTER //
// src/views/plus/ma_resp_signing/index/index.vue